export default {
  allTractHudSections: (state) => state.tractHudSections,
  tractHudSectionsLoading: (state) => state.loading
}
